import axios from 'axios';
import db from './db'; // Importe seu serviço de IndexedDB
import { encryptData, decryptData,encryptDataMatriz } from './cryptoUtils';
// Criar uma instância do Axios
const api = axios.create({
// baseURL: process.env.REACT_APP_API_URL || 'http://192.168.2.17:8095/',
 baseURL: process.env.REACT_APP_API_URL || 'https://rest.integracenter.com.br/mobile',
});

// Função para buscar o token do IndexedDB
const getTokenFromDB = async () => {
  try {

    const currentUser = await db.currentUser.get('currentUser');
    const storedUserSic = await db.currentUserSic.get('currentUser');
    if (currentUser) {
      const restoredUser = {
        token: decryptData(currentUser.token),
        empresa: decryptData(currentUser.empresa),
        matriz: decryptData(currentUser.matriz),

      };
      return restoredUser ? restoredUser.token : null;
    }
    if (storedUserSic) {
      const currentUserData = {
        id: 'currentUser',
        token: decryptData(storedUserSic.token),
        empresa: decryptData(storedUserSic.empresa),
        matriz: decryptData(storedUserSic.matriz),
        vendedorModel: decryptData(storedUserSic.vendedorModel), // Pode ser null
        // Aqui assumimos que matrizFilialDisponivel já vem como array ou objeto apropriado
        matrizFilialDisponivel: storedUserSic.matrizFilialDisponivel || null,
        matrizUnica: storedUserSic.matrizUnica,
        mobile: storedUserSic.mobile || null,
        sic: storedUserSic.sic,
        usuario: decryptData(storedUserSic.usuario),
        matrizSelecionada: decryptData(storedUserSic.matrizSelecionada || null)
      };
      console.log(currentUserData)
      return currentUserData ? currentUserData.token : null;
    }

  } catch (error) {
    console.error('Erro ao buscar o token do IndexedDB:', error);
    return null;
  }
};

const getMatrizFromDB = async () => {
  try {

   
    const storedUserSic = await db.currentUserSic.get('currentUser');    
    if (storedUserSic) {
      const currentUserData = {
        id: 'currentUser',
        token: decryptData(storedUserSic.token),
        empresa: decryptData(storedUserSic.empresa),
        matriz: decryptData(storedUserSic.matriz),
        vendedorModel: decryptData(storedUserSic.vendedorModel), // Pode ser null
        // Aqui assumimos que matrizFilialDisponivel já vem como array ou objeto apropriado
        matrizFilialDisponivel: storedUserSic.matrizFilialDisponivel || null,
        matrizUnica: storedUserSic.matrizUnica,
        mobile: storedUserSic.mobile || null,
        sic: storedUserSic.sic,
        usuario: decryptData(storedUserSic.usuario),
        matrizSelecionada: decryptData(storedUserSic.matrizSelecionada)
      };
      return currentUserData ? decryptData(storedUserSic.matrizSelecionada): null;
    }

  } catch (error) {
    console.error('Erro ao buscar o token do IndexedDB:', error);
    return null;
  }
};


// Interceptar requisições para adicionar o token no cabeçalho
api.interceptors.request.use(
  async (config) => {
    const token = await getTokenFromDB(); // Buscar o token do IndexedDB
    const matriz = await getMatrizFromDB();
    console.log(token)
    console.log('------->',matriz)
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
      config.headers['idMatrizFilial'] = `${matriz}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);



export default api;
